import React from "react";

export const bmi_result = {
  gender: "men",
  age: 20,
  height: 160,
  heightType: "cm",
  title1: "Get your Custom Tailored Keto Diet",
  title2: "Based on your answers, below is your report and you will be 55kg!",
  title3: "Your 28-day personalized keto diet plan is ready!",
  currentWeight: 89,
  targetWeight: 55,
  weightType: "kg",
  currentMonth: "Oct",
  nextMonth: "Nov",
  nextMonthTargetWeight: 84,
  metabolicAge: 30,
  waterIntake: "4-5",
  waterIntakeType: "L",
  bmr: "1736 - 1836",
  calorieunit: 1836,
  macros_fat_min: 146,
  macros_fat_max: 166,
  macros_protein_min: 50,
  macros_protein_max: 59,
  macros_carbs_min: 7,
  macros_carbs_max: 12,
  macros_Unit: "gram",
  bmrType: "cal",
  bmi: 35,
  bmrCategory: "Morbidly Obese",
  bmrCategoryGroup: [
    "Underweight",
    "Normal",
    "Overweight",
    "Moderately Obese",
    "Morbidly Obese",
    "Obese",
  ],
  riskIndicator: 0.75,
  diseaseRiskIndicator: "High bmi risk level",
  diseaseRiskIndicatorGroup: [
    "Green - Healthy",
    "Orange - Moderately healthy",
    "Red - Very unhealthy",
  ],
  stressLevelHappinessQuotient: "Highly Stressed",
  stressLevelHappinessQuotientGroup: [
    "Green - Happy",
    "Orange - Moderately Stressed",
    "Red - Highly Stressed",
  ],
  metabolismPowerQuotient: "Needs Attention",
  metabolismPowerQuotientGroup: [
    "Green- Excellent",
    "Orange- Fair",
    "Red- Needs Attention",
  ],
  dailyActivityWalking: "1 hr 30 mins",
  dailyActivitySport: "20 - 30 mins",
  foodvariations: "10000+",
  frequencyTimeslots: {
    us: {
      breakfast: "7-8",
      morning_snacks: "10-11",
      lunch: "13-14",
      evening_snacks: "17-18",
      dinner: "21-22",
    },
    uk: {
      breakfast: "7-8",
      morning_snacks: "10-11",
      lunch: "13-14",
      evening_snacks: "17-18",
      dinner: "21-22",
    },
    ca: {
      breakfast: "7-8",
      morning_snacks: "10-11",
      lunch: "13-14",
      evening_snacks: "17-18",
      dinner: "21-22",
    },
    aus: {
      breakfast: "7-8",
      morning_snacks: "10-11",
      lunch: "13-14",
      evening_snacks: "17-18",
      dinner: "21-22",
    },
  },
  description: {
    "Our promise":
      "<h2>Our promise</h2><p>We Strongly believe that following a healthy lifestyle is the best way to stay fit and in pink of your Health. KetoBalanced.com understands that you need a simple, easy to follow Customized diet meal plan which can help you become fit without trying too hard.</p><p>We also do Understand that there are many hurdles in staying fit and very little solutions which push you to stay on path, we promise to be with you in your journey and guide you through. With this important aspect in our mind, we create customized keto meal-plans just for you which taste great and are easy to make- not to mention they keep you healthy.</p><p>Our nutritionists and personal coaches make sure, you get a personalized meal plan with all your favorite food items in there. This keeps you motivated and helps you achieve your goal positively. Don&rsquo;t worry we are in this together!</p><p>Just Try our personalized keto meal-plan and enjoy every recipe without guilt as you know with every meal you are one step closer to your Goal.</p>",
  },
  expertimg: "https://kbcdn22.ketobalanced.com/899189596175l9fq9k.png",
};

export const pre_survey = {
  survey: {
    country: "us",
    surveyCategory: [
      "gender",
      "familiarity",
      "meal_preparation",
      "activity",
      "typical_day_for_you",
      "what_stands_true_for_you",
      "meat",
      "veggies",
      "other_food_items",
      "age",
      "weight",
      "height",
    ],
    surveyCategoryv3: [
      "gender",
      "meal_preparation",
      "activity",
      "typical_day_for_you",
      "what_stands_true_for_you",
      "meat",
      "veggies",
      "other_food_items",
      "age",
      "weight",
      "height",
      "current_body_type",
      "body_type_target",
      "easy_weight_loss_with_keto",
      "target_zones",
      "happy_weight",
      "motivation",
      "occasion",
    ],
    surveyItems: [
      {
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Start Losing Weight and Feeling Great within Days - Your Path to Healthier Living",
        pageSeq: 1,
        title1: "Lose extra weight with keto diet now",
        title2: "First, Select Your Gender:",
        categoryItems: [
          {
            itemId: "656aaa8f00877712279973d3",
            name: "Men",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363124048lqz1sr4g48.svg",
          },
          {
            itemId: "656aaaa700877712279973d4",
            name: "Women",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363127147lqz1stij147.svg",
          },
          {
            itemId: "62512c557d057d3d01bf8534",
            name: "Unknown",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        category: "gender",
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        id: "623058fc896cc388cb8272d8",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 4,
        title1: "How much time do you have for meal preparation each day?",
        title2: "How much time do you have for meal preparation each day?",
        category: "meal_preparation",
        categoryItems: [
          {
            itemId: "623058fc896c7858cb8272d5",
            name: "Up to 30 minutes",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "624fe1f4ac82160af58d959e",
            name: "Up to 1 hour",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "624fe1ddac82160af58d959d",
            name: "More than 1 hour",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62305fd3896cc388cb8272dc",
      },
      {
        description: "description",
        metaDescription: "meta description",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Keto Diet Awareness: How Familiar Are You? Exploring the Basics and Benefits",
        pageSeq: 2,
        title1: "Familiarity",
        title2: "How familiar are you with the keto diet?",
        category: "familiarity",
        categoryItems: [
          {
            itemId: "623058fc896c9888cb8272d5",
            name: "Expert",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "656aa77d00877712279973c2",
            name: "I've heard a thing or two",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "623058f9096cc388cb827235",
            name: "Beginner",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62305d4f896cc388cb8272da",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 7,
        title1: "Please select which product you would like to include",
        title2: "Other food items",
        category: "other_food_items",
        categoryItems: [
          {
            itemId: "6253ff478c1d51ca9bf5f616",
            name: "Egg",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366475737lqz3slax737.svg",
          },
          {
            itemId: "6253ff4a8c1d51ca9bf5f617",
            name: "Nuts",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366480525lqz3sozx525.svg",
          },
          {
            itemId: "6253ff4d8c1d51ca9bf5f618",
            name: "Cheese",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366486020lqz3st8k20.svg",
          },
          {
            itemId: "6253ff518c1d51ca9bf5f619",
            name: "Coconut",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366490316lqz3swjw316.svg",
          },
          {
            itemId: "6253ff548c1d51ca9bf5f61a",
            name: "Olives",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366498152lqz3t2lk152.svg",
          },
          {
            itemId: "6253ff588c1d51ca9bf5f61b",
            name: "Strawberry",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366507531lqz3t9u3531.svg",
          },
        ],
        id: "62306705896cc388cb8272df",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 21,
        title1: "How tall are you?",
        title2: "How tall are you?",
        category: "height",
        categoryItems: [
          {
            itemId: "6252805693a77190103f1279",
            name: "cm",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252805693a77800103f1279",
            name: "feet",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252805693a72000103f1279",
            name: "inch",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "625283d193a77197d03f127a",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 10,
        title1: "It is possible to select multiple answers",
        title2: "It is possible to select multiple answers",
        category: "what_stands_true_for_you",
        categoryItems: [
          {
            itemId: "625400158c1d51ca9bf5f625",
            name: "I do not get quality sleep",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "625400138c1d51ca9bf5f624",
            name: "I eat late at night",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "625400108c1d51ca9bf5f623",
            name: "My salt intake is more",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6254000d8c1d51ca9bf5f622",
            name: "I can not quit eating sweets",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6254000a8c1d51ca9bf5f621",
            name: "I like soft drinks",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "625400078c1d51ca9bf5f620",
            name: "None of the above",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62306925896cc388cb8272e2",
      },
      {
        metaDescription: "How excited are you to shed some extra weight?",
        metaKeyword: "How excited are you to shed some extra weight?",
        metaTitle: "How excited are you to shed some extra weight?",
        pageSeq: 594,
        title1: "How excited are you to shed some extra weight?",
        title2: "How excited are you to shed some extra weight?",
        category: "motivation",
        description: "How excited are you to shed some extra weight?",
        categoryItems: [
          {
            itemId: "65644043a1a8ed2f0ba0cafc",
            name: "I Just want to see what the buzz about fasting is about",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365003416lqz2x193416.svg",
          },
          {
            itemId: "65644043a1a8ed2f0ba0cafd",
            name: "I want to try and lose some weight",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365006724lqz2x3t0724.svg",
          },
          {
            itemId: "65644043a1a8ed2f0ba0cafe",
            name: "I'm serious about losing as much weight as possible",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365009348lqz2x5tw348.svg",
          },
        ],
        id: "65644043a1a8ed2f0ba0cafb",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 14,
        title1:
          "Enter your email to see your personalized Keto Diet for your target weight",
        title2:
          "Enter your email to see your personalized Keto Diet for your target weight",
        category: "email",
        categoryItems: [],
        id: "62307db4896cc388cb8272e6",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 6,
        title1: "Please select which veggies you would like to include",
        title2: "Veggies",
        category: "veggies",
        categoryItems: [
          {
            itemId: "6253fe5a8c1d51ca9bf5f605",
            name: "Broccoli",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366332019lqz3pier19.svg",
          },
          {
            itemId: "6253fe648c1d51ca9bf5f606",
            name: "Mushrooms",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366341150lqz3ppge150.svg",
          },
          {
            itemId: "6253fe708c1d51ca9bf5f607",
            name: "Zucchini",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366351761lqz3pxn5761.svg",
          },
          {
            itemId: "6253fe7a8c1d51ca9bf5f608",
            name: "Cauliflower",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366356678lqz3q1fq678.svg",
          },
          {
            itemId: "6253fe848c1d51ca9bf5f609",
            name: "Asparagus",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366361493lqz3q55h493.svg",
          },
          {
            itemId: "6253fee38c1d51ca9bf5f60a",
            name: "Avacado",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366365689lqz3q8e1689.svg",
          },
          {
            itemId: "6253fee68c1d51ca9bf5f60b",
            name: "Green Beans",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366379360lqz3qixs360.svg",
          },
          {
            itemId: "6253fee88c1d51ca9bf5f60c",
            name: "Cabbage",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366385642lqz3qnsa642.svg",
          },
          {
            itemId: "6253feeb8c1d51ca9bf5f60d",
            name: "Spinach",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366402989lqz3r165989.svg",
          },
          {
            itemId: "6253feef8c1d51ca9bf5f60e",
            name: "Lettuce",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366393803lqz3qu2z803.svg",
          },
          {
            itemId: "6253fef38c1d51ca9bf5f60f",
            name: "Brussels Sprouts",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366413667lqz3r9er667.svg",
          },
          {
            itemId: "6253fef68c1d51ca9bf5f610",
            name: "Arugula",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366408356lqz3r5b8356.svg",
          },
          {
            itemId: "6253fefa8c1d51ca9bf5f611",
            name: "Spring Onions",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366421268lqz3rf9w268.svg",
          },
          {
            itemId: "6253fefd8c1d51ca9bf5f612",
            name: "Bok-Choy",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366428641lqz3rkyp641.svg",
          },
          {
            itemId: "6253ff008c1d51ca9bf5f613",
            name: "Bell Pepper",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366432793lqz3ro61793.svg",
          },
          {
            itemId: "6253ff038c1d51ca9bf5f614",
            name: "Eggplant",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366437817lqz3rs1l817.svg",
          },
          {
            itemId: "6253ff058c1d51ca9bf5f615",
            name: "Radish",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366448827lqz3s0jf827.svg",
          },
        ],
        id: "623065ab896cc388cb8272de",
      },
      {
        description:
          "Before We go further with our Short Quiz which helps our Experts Design Best Meal Plan Just for You according to your needs. We want you to know that you have made a Perfect Choice. Want to Know Why? Here We go.",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 3,
        title1: "What do you want to achieve?",
        title2: "You can select multiple goal.",
        category: "easy_weight_loss_with_keto",
        categoryItems: [
          {
            itemId: "65643c42a3c81798bd3b4236",
            name: "Loose weight",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363964865lqz2arwh865.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b4237",
            name: "Increase life expectancy",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363967750lqz2au4m750.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b4238",
            name: "Boost brain power",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363970252lqz2aw24252.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b4239",
            name: "Improve blood presure",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363973015lqz2ay6v15.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b423a",
            name: "Reduce cholesterol level",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363975823lqz2b0cv823.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b423b",
            name: "Sleep better",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363980275lqz2b3sj275.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b423c",
            name: "Improve bone health",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363983524lqz2b6as524.svg",
          },
          {
            itemId: "65643c42a3c81798bd3b423d",
            name: "Reduce the risk of cancer",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363986772lqz2b8t0772.svg",
          },
        ],
        id: "62305f39896cc388cb8272db",
      },
      {
        metaDescription:
          "ketobalanced.com, Fasting hours tracked in our web and app",
        metaKeyword:
          "ketobalanced.com, Fasting hours tracked in our web and app",
        metaTitle: "ketobalanced.com, Fasting hours tracked in our web and app",
        pageSeq: 221,
        title1: "100,300,000+",
        title2: "Dieting hours tracked in our app",
        category: "social_proof",
        description:
          "ketobalanced.com, Fasting hours tracked in our web and app",
        categoryItems: [
          {
            itemId: "65643f56a1a8ed2f0ba0cab7",
            name: "mens",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364130948lqz2ec1w948.svg",
          },
          {
            itemId: "65643f56a1a8ed2f0ba0cab8",
            name: "womens",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364133011lqz2edn711.svg",
          },
        ],
        id: "65643f56a1a8ed2f0ba0cab6",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 17,
        title1: "Lifetime Access to our Workout Video",
        title2: "",
        category: "upsel2",
        categoryItems: [],
        id: "6241b17db73a9d97bdc4fa4d",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 18,
        title1: "Sweet & Tasty Way To Weight Loss",
        title2: "",
        category: "upsel3",
        categoryItems: [],
        id: "6241b37db73a9d97bdc4fa4e",
      },
      {
        metaDescription: "The body type you want to have",
        metaKeyword: "The body type you want to have",
        metaTitle: "The body type you want to have",
        pageSeq: 642,
        title1: "Choose the body type you want to have",
        title2: "Choose the body type you want to have",
        category: "body_type_target",
        description: "The body type you want to have",
        categoryItems: [
          {
            itemId: "65643e8da1a8ed2f0ba0ca97",
            name: "Fit",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363827515lqz27tx7515.svg",
          },
          {
            itemId: "65643e8da1a8ed2f0ba0ca98",
            name: "Cut",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363832402lqz27xoy402.svg",
          },
          {
            itemId: "65643e8da1a8ed2f0ba0ca99",
            name: "Bulk",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363837101lqz281bh101.svg",
          },
          {
            itemId: "65643e8da1a8ed2f0ba0ca9a",
            name: "Fit",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363843502lqz2869a502.svg",
          },
          {
            itemId: "65643e8da1a8ed2f0ba0ca9b",
            name: "Cut",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363846918lqz288w6918.svg",
          },
          {
            itemId: "65643e8da1a8ed2f0ba0ca9c",
            name: "Bulk",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363852446lqz28d5q446.svg",
          },
        ],
        id: "65643e8da1a8ed2f0ba0ca96",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 15,
        title1: "What you get with your Keto Diet plan?",
        title2: "The most popular Keto Diet! Over 62699 plans ordered.",
        category: "payment_validation",
        categoryItems: [],
        id: "62307e07896cc388cb8272e7",
      },
      {
        metaDescription: "Body Type, target zones",
        metaKeyword: "Body Type, target zones",
        metaTitle: "Body Type, target zones",
        pageSeq: 825,
        title1: "Choose your target zones",
        title2: "Choose your target zones",
        category: "target_zones",
        description: "Body Type, target zones",
        categoryItems: [
          {
            itemId: "65643fb1a1a8ed2f0ba0cacb",
            name: "Belly",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364235705lqz2gkvt705.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cacc",
            name: "Butt",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364239152lqz2gnjk152.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cacd",
            name: "Pecs",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364242938lqz2gqgq938.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cace",
            name: "Legs",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364247075lqz2gtnn75.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cacf",
            name: "Belly",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364251654lqz2gx6u654.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cad0",
            name: "Butt",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364255064lqz2gztk64.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cad1",
            name: "Pecs",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364260415lqz2h3y7415.svg",
          },
          {
            itemId: "65643fb1a1a8ed2f0ba0cad2",
            name: "Legs",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364263431lqz2h69z431.svg",
          },
        ],
        id: "65643fb1a1a8ed2f0ba0caca",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 12,
        title1: "What is your current weight?",
        title2: "What would you consider your perfect weight?",
        category: "weight",
        categoryItems: [
          {
            itemId: "656aa2ac00877712279973b3",
            name: "weight",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "623058fc896cc388cb827235",
            name: "target weight",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252852093a77197d03f127b",
            name: "kg",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252892b93a77197d03f127c",
            name: "lb",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62307236896cc388cb8272e4",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 19,
        title1: "Unlimited Access to the Panel of Diet Experts",
        title2: "",
        category: "upsel4",
        categoryItems: [],
        id: "6241b3d3b73a9d97bdc4fa4f",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 8,
        title1: "How active are you?",
        title2: "How active are you?",
        category: "activity",
        categoryItems: [
          {
            itemId: "6252eebb93a77197d03f127d",
            name: "Almost no physical activity",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252eec693a77197d03f127e",
            name: "I often go for a walk",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252eed193a77197d03f127f",
            name: "I exercise 1-2 times a week",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252eedc93a77197d03f1280",
            name: "I exercise 3-5 times a week",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252eee893a77197d03f1281",
            name: "I exercise 5-7 times a week",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62306771896cc388cb8272e0",
      },
      {
        metaDescription: "current body type",
        metaKeyword: "current body type",
        metaTitle: "current body type",
        pageSeq: 715,
        title1: "Choose your current body type",
        title2: "Choose your current body type",
        category: "current_body_type",
        description: "current body type",
        categoryItems: [
          {
            itemId: "65646d0564b1536caefb4e9e",
            name: "Average",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363514901lqz214ph901.svg",
          },
          {
            itemId: "65646d0564b1536caefb4e9f",
            name: "Plump",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363522278lqz21aee278.svg",
          },
          {
            itemId: "65646d0564b1536caefb4ea0",
            name: "Extra",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "men",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363525930lqz21d7u930.svg",
          },
          {
            itemId: "65646d0564b1536caefb4ea1",
            name: "Average",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363691594lqz24x1m594.svg",
          },
          {
            itemId: "65646d0564b1536caefb4ea2",
            name: "Plump",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363695069lqz24zq569.svg",
          },
          {
            itemId: "65646d0564b1536caefb4ea3",
            name: "Extra",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "women",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704363700109lqz253m5109.svg",
          },
        ],
        id: "65646d0564b1536caefb4e9d",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 16,
        title1: "Get your meal plan within Just 45 Minutes",
        title2: "",
        category: "upsel1",
        categoryItems: [],
        id: "6241b095b73a9d97bdc4fa4c",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 13,
        title1: "Your 28-day personalized keto diet plan is ready!",
        title2: "Summary of your overall wellness",
        category: "your_profile_summary",
        categoryItems: [],
        id: "62307900896cc388cb8272e5",
      },
      {
        metaDescription: "when were you last happy with your weight",
        metaKeyword: "when were you last happy with your weight",
        metaTitle: "when were you last happy with your weight",
        pageSeq: 845,
        title1: "when were you last happy with your weight?",
        title2: "when were you last happy with your weight?",
        category: "happy_weight",
        description: "when were you last happy with your weight",
        categoryItems: [
          {
            itemId: "65643ffca1a8ed2f0ba0caeb",
            name: "Less than a year ago",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364383320lqz2jqs8320.svg",
          },
          {
            itemId: "65643ffca1a8ed2f0ba0caec",
            name: "1 to 2 years ago",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364385613lqz2jsjx613.svg",
          },
          {
            itemId: "65643ffca1a8ed2f0ba0caed",
            name: "More than 4 years ago",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364388027lqz2juez27.svg",
          },
          {
            itemId: "65643ffca1a8ed2f0ba0caee",
            name: "Never",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704364390821lqz2jwkl821.svg",
          },
        ],
        id: "65643ffca1a8ed2f0ba0caea",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 20,
        title1: "Thank You for choosing our Keto Meal Plan!",
        title2: "",
        category: "thank_you",
        categoryItems: [],
        id: "6241b72eb73a9d97bdc4fa50",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 9,
        title1: "How you spend your day?",
        title2: "How you spend your day?",
        category: "typical_day_for_you",
        categoryItems: [
          {
            itemId: "6252f02193a77197d03f1282",
            name: "At workplace",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6253ffa28c1d51ca9bf5f61c",
            name: "At workplace but i happen to go out regularly",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6253ffa58c1d51ca9bf5f61d",
            name: "I spend pretty much time on foot",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6253ffa88c1d51ca9bf5f61e",
            name: "Manual labor",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6253ffab8c1d51ca9bf5f61f",
            name: "I stay at home very often",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "62306842896cc388cb8272e1",
      },
      {
        metaDescription:
          "Is there a special occasion you want to lose weight for?",
        metaKeyword: "Is there a special occasion you want to lose weight for?",
        metaTitle: "Is there a special occasion you want to lose weight for?",
        pageSeq: 790,
        title1: "Is there a special occasion you want to lose weight for?",
        title2: "Is there a special occasion you want to lose weight for?",
        category: "occasion",
        description: "Is there a special occasion you want to lose weight for?",
        categoryItems: [
          {
            itemId: "656440b9a1a8ed2f0ba0cb0c",
            name: "Vacation",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365712751lqz3c8kv751.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb0d",
            name: "Wedding",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365716683lqz3cbm3683.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb0e",
            name: "Sporting event",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365719844lqz3ce1w844.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb0f",
            name: "Beach trip",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365723328lqz3cgqo328.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb10",
            name: "Reunion",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365726319lqz3cj1r319.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb11",
            name: "Family occasion",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365729569lqz3clk1569.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb12",
            name: "Other",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365732862lqz3co3i862.svg",
          },
          {
            itemId: "656440b9a1a8ed2f0ba0cb13",
            name: "No",
            dark_icon: "",
            light_icon: "",
            isVal: 0,
            isTrue: 0,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704365736024lqz3cqjc24.svg",
          },
        ],
        id: "656440b9a1a8ed2f0ba0cb0b",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 11,
        title1: "What is your age?",
        title2: "What is your age?",
        category: "age",
        categoryItems: [
          {
            itemId: "623058fc896cc388cb8272d5",
            name: "age",
            dark_icon: "",
            light_icon: "",
            isVal: 50,
            isTrue: 50,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
          {
            itemId: "6252805693a77197d03f1279",
            name: "year",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/111111111111773l9kx8bal773.png",
          },
        ],
        id: "623071d0896cc388cb8272e3",
      },
      {
        description:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        metaDescriptin: "meta description",
        metaKeyword: "ketobalanced",
        metaTitle:
          "Lose Extra Weight with Keto Diet Now - Your Path to Healthier Living",
        pageSeq: 5,
        title1: "Please select which meat you would like to include",
        title2: "Meat",
        category: "meat",
        categoryItems: [
          {
            itemId: "624fe27dac82160af58d959f",
            name: "Chicken",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366265705lqz3o38p705.svg",
          },
          {
            itemId: "624fe281ac82160af58d95a0",
            name: "Pork",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366272136lqz3o87c136.svg",
          },
          {
            itemId: "624fe285ac82160af58d95a1",
            name: "Beef",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366278262lqz3ocxi262.svg",
          },
          {
            itemId: "624fe289ac82160af58d95a2",
            name: "Fish",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366283521lqz3ogzl521.svg",
          },
          {
            itemId: "624fe28dac82160af58d95a3",
            name: "Seafood",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366290380lqz3oma4380.svg",
          },
          {
            itemId: "624fe291ac82160af58d95a4",
            name: "Lamb",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366296448lqz3oqyo448.svg",
          },
          {
            itemId: "624fe295ac82160af58d95a5",
            name: "I am Vegetarian",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366299837lqz3otkt837.svg",
          },
          {
            itemId: "624fe299ac82160af58d95a6",
            name: "I am Vegan",
            dark_icon: "",
            light_icon: "",
            isVal: null,
            isTrue: null,
            subcat: "",
            imgname:
              "https://kbcdn22.ketobalanced.com/1704366305267lqz3oxrn267.svg",
          },
        ],
        metaDescription:
          "ketobalanced.com helps you understand the science of ketogenic diet better. why the keto Diet works better as a weight loss program. It creates a personalized keto meal plan with over 15,000 keto recipes to improve your health and weight loss management. Tasty, high Fat, low carb diet recipes, easy to cook and follow !",
        id: "6230623c896cc388cb8272dd",
      },
      {
        metaDescription: "Registration",
        metaKeyword: "Registration",
        metaTitle: "Registration",
        pageSeq: 435,
        title1: "Registration",
        title2: "Registration",
        category: "register_form",
        description: "Registration",
        categoryItems: [],
        id: "656440eea1a8ed2f0ba0cb20",
      },
    ],
    validation: {
      ageMin: 18,
      ageMax: 60,
      heightCmMin: 135,
      heightCmMax: 213,
      heightFtMin: 3,
      heightftMax: 6,
      currentWeightkgMin: 43,
      targetWeightkgMin: 40,
      currentWeightKgMax: 183,
      targetWeightKgMax: 180,
      currentTargetWeightKgDiffMin: 3,
      currentWeightLbMin: 95,
      targetWeightLbMin: 88,
      currentWeightLbMax: 403,
      targetWeightLbMax: 396,
      currentTargetWeightLbDiffMin: 6,
      password_min: 6,
      password_max: 20,
      input_max: 100,
      textarea_max: 500,
      img_fileSize_byte: 10485760,
      vid_fileSize_byte: 10485760,
      mobilenovalidation: {
        default: 15,
        usa: 15,
        us: 15,
        uk: 15,
        ca: 15,
        aus: 15,
      },
      recommendationMessage:
        "Ouch! Something went wrong!<br> It seems you probably need expert's supervision to achieve your dream body. Kindly drop an email at support@ketobalanced.com or you can retry again",
      watertake_max_post: 1000,
    },
    company_address: [
      {
        company: "AVV MEDIA SERVICES LLP",
        address:
          "SDF NO. I-10B, NOIDA SPECIAL ECONOMIC ZONE, NOIDADADRI ROAD, PHASE-II, NOIDA, U.P 201305",
      },
      {
        company: "AVV ENTERPRISES PRIVATE LIMITED",
        address:
          "B-30 3RD FLOOR, CHANDRAGUPT COMPLEX SUBHASH CHOWK, VIKAS MARG, LAXMI NAGAR NEW DELHI 110092",
      },
    ],
  },
};

export const pre_register = {
  responce: {
    plan: [
      {
        name: "3 Month(s) Keto diet",
        category: "DIGITAL_GOODS",
        description:
          "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
        sku: "3 Month(s) Keto diet",
        imageUrl:
          "https://kbcdn22.ketobalanced.com/1692118112715llcjfnwr715.png",
        price: "68",
        before_dpw: "5",
        pricePerWeek: "3.33",
        credits: "38",
        country: "us",
        currency: "usd",
        refunds: "allowed",
        recurring: "yes",
        ordSeq: 1,
        subTag: "subscription",
        isTrue: true,
        subTitle: "3 Month(s) Keto diet Billed every 3 month(s)",
        title: "Get your Custom Tailored Keto Diet",
        id: "625941d196ecfc36e9b66553",
        ketoios: "kb_3mon_40",
      },
      {
        name: "6 Month(s) Keto diet",
        category: "DIGITAL_GOODS",
        description:
          "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
        sku: "6 Month(s) Keto diet",
        imageUrl:
          "https://kbcdn22.ketobalanced.com/1692117837988llcj9rxg988.png",
        price: "130",
        before_dpw: "5",
        pricePerWeek: "1.90",
        credits: "49",
        country: "us",
        currency: "usd",
        refunds: "allowed",
        recurring: "yes",
        ordSeq: 4,
        subTag: "subscription",
        isTrue: true,
        subTitle: "6 Month(s) Keto diet Billed every 6 month(s)",
        title: "Get your Custom Tailored Keto Diet",
        id: "626fa3a5cbdf1dbfe4481d42",
        ketoios: "kb_6mon_80",
      },
      {
        name: "12 Month(s) Keto diet",
        category: "DIGITAL_GOODS",
        description:
          "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
        sku: "12 Month(s) Keto diet",
        imageUrl:
          "https://kbcdn22.ketobalanced.com/1692117524405llcj31yt405.png",
        price: "264",
        before_dpw: "5",
        pricePerWeek: "1.45",
        credits: "75",
        country: "us",
        currency: "usd",
        refunds: "allowed",
        recurring: "yes",
        ordSeq: 7,
        subTag: "subscription",
        isTrue: true,
        subTitle: "12 Month(s) Keto diet Billed every 12 month(s)",
        title: "Get your Custom Tailored Keto Diet",
        id: "62da9ac1726ab9588506fdf8",
        ketoios: "kb_12mon_120",
      },
    ],
    signedId: "6527cd550867f3fecac6cb88",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2OTc3OTc1MTIsImV4cCI6MTY5NzgwMTExMiwiYXVkIjoiNjUyN2NkNTUwODY3ZjNmZWNhYzZjYjg2IiwiaXNzIjoia2V0b2JhbGFuY2VkLmNvbSJ9.HX3cp_79aErKRi1tza88Jx6y6_3kHsqlcm2ezfwdWDY",
    refreshToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2OTc3OTc1MTIsImV4cCI6MTcyOTM1NTExMiwiYXVkIjoiNjUyN2NkNTUwODY3ZjNmZWNhYzZjYjg2IiwiaXNzIjoia2V0b2JhbGFuY2VkLmNvbSJ9.Gwqo8TFnsOKwbESblv0IVA7kczqHaqPb8roeYX5_y1U",
    CLIENT_ID: "",
    caseStudy: {
      message:
        "Almost at the finish line! Only the plan awaits before your exciting journey begins",
      topTitle1: "Similar people who have lost 10 kgs with keto",
      allPoints: {
        title: "What you get",
        list: [
          "Pre-calculated portion sizes based on your habits and preferences",
          "Easy-to-cook delicious recipes with step-by-step preparation guide",
          'High quality "How to cook" videos',
          "Printable weekly shopping list with all ingredients",
          "Access to VIP Keto Content with lifestyle tips and more recipes",
          "Choose your plan",
        ],
      },
      successStories: {
        title: "Success Stories From Our Users",
        image: "https://kbcdn22.ketobalanced.com/1692174289230lldgvpzi230.gif",
        stories:
          "Never believed keto foods can be this delicious. All the recipes I found on my meal plan were super easy to make and contained adequate nutrition. I can now eat mouth-watering keto foods all thanks to KetoBalanced. I highly recommend this to anyone looking for a keto diet plan.",
      },
      KetoBenefits: {
        title: "Keto benefits",
        list: [
          "Sustainable weight loss",
          "Reduced risk of inflammation",
          "It can reduce insulin resistance, lowering blood sugar by 3–6% and insulin levels by 20–31%",
          "Printable weekly shopping list with all ingredients",
          'Reduces "bad" LDL cholesterol, blood triglycerides, inflammatory markers, and blood sugar',
          "Increases sleep quality; accelerates metabolism",
        ],
      },
      "achivedResults ": {
        title: "People just like you, achieved great results using keto!",
        images: [
          "https://kbcdn22.ketobalanced.com/1692174289257lldgvq09257.png",
        ],
      },
      "feedBack ": {
        title: "What people say",
        list: [
          {
            user: "https://kbcdn22.ketobalanced.com/1692174289289lldgvq15289.png",
            name: "Rentia Steyn",
            feedback:
              "Never imagined keto could do such won-ders tio my health. I've been following for last a few months and lost 32 lbs for now and trust mecutting carbs is bliss to me. Love!",
          },
          {
            user: "https://kbcdn22.ketobalanced.com/1692174289291lldgvq17291.png",
            name: "Carmen Harris",
            feedback:
              "Brilliant plan! | was first sceptical about it but once started, all my doubt has gone away now and the results? OMG! It's unbelievable! All thanks to this keto meal plan!",
          },
          {
            user: "https://kbcdn22.ketobalanced.com/1693403129623llxsi1av623.png",
            name: "Stephanie Ortego",
            feedback:
              "I couldn't ever imagine that | could ever restrain my food cravings but this keto never lets me feel deprived of anything | love to eat. Such an awesome and amaz- ingly designed meal plan it is!!",
          },
          {
            user: "https://kbcdn22.ketobalanced.com/1692174289293lldgvq19293.png",
            name: "Hamsa Oueity Amin",
            feedback:
              "This high fat-low carb thing really worked forme and | got an extraordinary result out of this. Plus my blood sugar and other related ailments are under control now. Wow!",
          },
          {
            user: "https://kbcdn22.ketobalanced.com/1692174289304lldgvq1k304.png",
            name: "Teresa Coleman",
            feedback:
              "Been doing keto for last a couple of months and it takes care all of my snack and dessert craving as well as helps me shed pounds in such a short period of time. Amazing!",
          },
          {
            user: "https://kbcdn22.ketobalanced.com/1692174289306lldgvq1m306.png",
            name: "Allison Gabrielle",
            feedback:
              "Nothing could beat this high fat and low carb combo when you're sincerely looking for weight loss. I'm saying this because | have been doing this.",
          },
        ],
      },
    },
    finalMessage:
      "Almost at the finish line! Only the plan awaits before your exciting journey begins",
    paymentList: {
      paypal: false,
      payglocal: true,
      stripe: false,
      stickypaypal: true,
    },
  },
};

export const email_state = {
  pathname: "/final.php",
  search: "",
  hash: "",
  state: {
    responce: {
      plan: [
        {
          name: "1 Month Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "1 Month Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319776770lo73quiq770.png",
          price: "43.70",
          before_dpw: "10.93",
          pricePerWeek: "5.46",
          titlePerWeekDay: "per week",
          credits: "21.85",
          creditsios: "14.99",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 753,
          planOrd: 1,
          isPlanRemark: "",
          subTag: "subscription",
          isTrue: false,
          subTitle: "1 Month Keto diet Billed every 1 month",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f6701c8a73844a6bb8a07c",
          ketoios: "kb_1mon_21_85_us_27sep24",
          valueAdded: [
            "Free keto E-books",
            "Limited Workout videos",
            "Limited Recipe videos",
            "",
            "",
            "",
            "",
            "",
          ],
        },
        {
          name: "6 Month(s) Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "6 Month(s) Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319618641lo73ngi9641.png",
          price: "237.92",
          before_dpw: "9.15",
          pricePerWeek: "2.29",
          titlePerWeekDay: "per week",
          credits: "59.48",
          creditsios: "54.90",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 452,
          planOrd: 1,
          isPlanRemark: "Most Popular",
          subTag: "subscription",
          isTrue: true,
          subTitle: "6 Month(s) Keto diet Billed every 6 month(s)",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f671728a73844a6bb8a0a9",
          ketoios: "kb_6mon_59_48_us_27sep24",
          valueAdded: [
            "Free keto E-books",
            "All Recipe videos",
            "Meal customization & Ingredient swap",
            "Talk with live keto Experts",
            "All Workout videos",
            "Yoga videos exclusive for you",
            "Mobility videos",
            "Keto Road Trip Guide",
          ],
        },
        {
          name: "3 Month(s) Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "3 Month(s) Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319439263lo73jm3j263.png",
          price: "88.75",
          before_dpw: "7.40",
          pricePerWeek: "2.96",
          titlePerWeekDay: "per week",
          credits: "35.50",
          creditsios: "35.90",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 479,
          planOrd: 1,
          isPlanRemark: "",
          subTag: "subscription",
          isTrue: false,
          subTitle: "3 Month(s) Keto diet Billed every 3 month(s)",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f6737e8a73844a6bb8a0d5",
          ketoios: "kb_3mon_40",
          valueAdded: [
            "Free keto E-books",
            "All Recipe videos",
            "Meal customization & Ingredient swap",
            "All Workout videos",
            "",
            "",
            "",
            "",
          ],
        },
      ],
      discountedplan: [
        {
          name: "1 Month Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "1 Month Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319776770lo73quiq770.png",
          price: "43.70",
          before_dpw: "10.93",
          pricePerWeek: "5.46",
          titlePerWeekDay: "per week",
          credits: "21.85",
          creditsios: "14.99",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 753,
          planOrd: 1,
          isPlanRemark: "",
          subTag: "subscription",
          isTrue: false,
          subTitle: "1 Month Keto diet Billed every 1 month",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f6701c8a73844a6bb8a07c",
          ketoios: "kb_1mon_21_85_us_27sep24",
          valueAdded: [
            "Free keto E-books",
            "Limited Workout videos",
            "Limited Recipe videos",
            "",
            "",
            "",
            "",
            "",
          ],
          discounted_pcr_before: 60,
          discounted_pcr: 78,
        },
        {
          name: "6 Month(s) Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "6 Month(s) Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319618641lo73ngi9641.png",
          price: "237.92",
          before_dpw: "9.15",
          pricePerWeek: "2.29",
          titlePerWeekDay: "per week",
          credits: "59.48",
          creditsios: "54.90",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 452,
          planOrd: 1,
          isPlanRemark: "Most Popular",
          subTag: "subscription",
          isTrue: true,
          subTitle: "6 Month(s) Keto diet Billed every 6 month(s)",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f671728a73844a6bb8a0a9",
          ketoios: "kb_6mon_59_48_us_27sep24",
          valueAdded: [
            "Free keto E-books",
            "All Recipe videos",
            "Meal customization & Ingredient swap",
            "Talk with live keto Experts",
            "All Workout videos",
            "Yoga videos exclusive for you",
            "Mobility videos",
            "Keto Road Trip Guide",
          ],
          discounted_pcr_before: 60,
          discounted_pcr: 78,
        },
        {
          name: "3 Month(s) Keto diet",
          category: "DIGITAL_GOODS",
          description:
            "<p>The most popular Keto Diet! Over&nbsp;62708&nbsp;plans ordered.</p>\r\n",
          sku: "3 Month(s) Keto diet",
          imageUrl:
            "https://kbcdn22.ketobalanced.com/1698319439263lo73jm3j263.png",
          price: "88.75",
          before_dpw: "7.40",
          pricePerWeek: "2.96",
          titlePerWeekDay: "per week",
          credits: "35.50",
          creditsios: "35.90",
          country: "us",
          currency: "USD",
          refunds: "allowed",
          recurring: "yes",
          ordSeq: 479,
          planOrd: 1,
          isPlanRemark: "",
          subTag: "subscription",
          isTrue: false,
          subTitle: "3 Month(s) Keto diet Billed every 3 month(s)",
          title: "Get your Custom Tailored Keto Diet",
          id: "66f6737e8a73844a6bb8a0d5",
          ketoios: "kb_3mon_40",
          valueAdded: [
            "Free keto E-books",
            "All Recipe videos",
            "Meal customization & Ingredient swap",
            "All Workout videos",
            "",
            "",
            "",
            "",
          ],
          discounted_pcr_before: 60,
          discounted_pcr: 78,
        },
      ],
      signedId: "6824671c66c4a564e26136e9",
      accessToken:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NDk0NzE5OTcsImV4cCI6MTc0OTQ3NTU5NywiYXVkIjoiNjgyNDY3MWI2NmM0YTU2NGUyNjEzNmU2IiwiaXNzIjoia2V0b2JhbGFuY2VkLmNvbSJ9.sB1neWMY6w_iL3LXKx_bkYbQD97TEBH4vbzMc-aj6Bc",
      refreshToken:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NDk0NzE5OTcsImV4cCI6MTc4MTAyOTU5NywiYXVkIjoiNjgyNDY3MWI2NmM0YTU2NGUyNjEzNmU2IiwiaXNzIjoia2V0b2JhbGFuY2VkLmNvbSJ9.PjuSZeK1K5iLJxuMIwj2QkgjnHR9w-mIJTY1o_92zb8",
      CLIENT_ID:
        "AUf6Jh8viomIa90m8KMFndz2iIwKkIcpzZHTUmKY1f8M9J7uDeQ1zO7d-lTb85AU4oiBHBlb2mBZ9g9_",
      caseStudy: {
        message:
          "Your last transaction didn't go through successfully.Please try again",
        topTitle1: "Similar people who have lost 10 kgs with keto",
        allPoints: {
          title: "What you get",
          list: [
            "Pre-calculated portion sizes based on your habits and preferences",
            "Easy-to-cook delicious recipes with step-by-step preparation guide",
            'High quality "How to cook" videos',
            "Printable weekly shopping list with all ingredients",
            "Access to VIP Keto Content with lifestyle tips and more recipes",
            "Choose your plan",
          ],
        },
        successStories: {
          title: "Success Stories From Our Users",
          image:
            "https://kbcdn22.ketobalanced.com/1692174289230lldgvpzi230.gif",
          stories:
            "Never believed keto foods can be this delicious. All the recipes I found on my meal plan were super easy to make and contained adequate nutrition. I can now eat mouth-watering keto foods all thanks to KetoBalanced. I highly recommend this to anyone looking for a keto diet plan.",
        },
        KetoBenefits: {
          title: "Keto benefits",
          list: [
            "Sustainable weight loss",
            "Reduced risk of inflammation",
            "It can reduce insulin resistance, lowering blood sugar by 3–6% and insulin levels by 20–31%",
            "Printable weekly shopping list with all ingredients",
            'Reduces "bad" LDL cholesterol, blood triglycerides, inflammatory markers, and blood sugar',
            "Increases sleep quality; accelerates metabolism",
          ],
        },
        achivedResults: {
          title: "People just like you, achieved great results using keto!",
          images: [
            "https://kbcdn22.ketobalanced.com/1692174289257lldgvq09257.png",
          ],
        },
        feedBack: {
          title: "What people say",
          list: [
            {
              user: "https://kbcdn22.ketobalanced.com/1692174289289lldgvq15289.png",
              name: "Rentia Steyn",
              feedback:
                "Never imagined keto could do such won-ders tio my health. I've been following for last a few months and lost 32 lbs for now and trust mecutting carbs is bliss to me. Love!",
            },
            {
              user: "https://kbcdn22.ketobalanced.com/1693403129623llxsi1av623.png",
              name: "Carmen Harris",
              feedback:
                "Brilliant plan! | was first sceptical about it but once started, all my doubt has gone away now and the results? OMG! It's unbelievable! All thanks to this keto meal plan!",
            },
            {
              user: "https://kbcdn22.ketobalanced.com/1701071512062lpgm232662.png",
              name: "Stephanie Ortego",
              feedback:
                "I couldn't ever imagine that | could ever restrain my food cravings but this keto never lets me feel deprived of anything | love to eat. Such an awesome and amaz- ingly designed meal plan it is!!",
            },
            {
              user: "https://kbcdn22.ketobalanced.com/1692174289293lldgvq19293.png",
              name: "Hamsa Oueity Amin",
              feedback:
                "This high fat-low carb thing really worked forme and | got an extraordinary result out of this. Plus my blood sugar and other related ailments are under control now. Wow!",
            },
            {
              user: "https://kbcdn22.ketobalanced.com/1692174289304lldgvq1k304.png",
              name: "Teresa Coleman",
              feedback:
                "Been doing keto for last a couple of months and it takes care all of my snack and dessert craving as well as helps me shed pounds in such a short period of time. Amazing!",
            },
            {
              user: "https://kbcdn22.ketobalanced.com/1692174289306lldgvq1m306.png",
              name: "Allison Gabrielle",
              feedback:
                "Nothing could beat this high fat and low carb combo when you're sincerely looking for weight loss. I'm saying this because | have been doing this.",
            },
          ],
        },
      },
      finalMessage:
        "Your last transaction didn't go through successfully.Please try again",
      paymentList: {
        paypal: false,
        payglocal: true,
        stripe: false,
        stickypaypal: true,
        squareup: true,
      },
      encryptEmail: "6824671c66c4a564e26136e9eyJhbGciO@ketobalanced.com",
    },
  },
  key: "shou1lk1",
};
